module.exports = __webpack_public_path__ + "static/media/erp-business-3.ec866203.png";